/* ============================================================
   PUREFACTOR - SIGNAL
   Cart, drawers, search and motion.
   Money maths is NEVER done here. The cart drawer re-renders from
   Liquid via the Section Rendering API so currency, discounts and
   the free-shipping maths stay in one place.
   ============================================================ */
(function () {
  'use strict';

  var body = document.body;

  /* ---------- helpers ---------- */
  function on(sel, ev, fn, root) {
    (root || document).addEventListener(ev, function (e) {
      var t = e.target.closest ? e.target.closest(sel) : null;
      if (t) fn(e, t);
    });
  }

  function focusTrap(el) {
    var f = el.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])');
    if (!f.length) return function () {};
    var first = f[0], last = f[f.length - 1];
    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    el.addEventListener('keydown', handler);
    return function () { el.removeEventListener('keydown', handler); };
  }

  /* ---------- drawers ---------- */
  var lastFocus = null, releaseTrap = null;

  function openDrawer(cls, el) {
    lastFocus = document.activeElement;
    body.classList.add(cls);
    if (el) {
      var close = el.querySelector('[data-close]');
      if (close) close.focus();
      releaseTrap = focusTrap(el);
    }
  }

  function closeDrawers() {
    body.classList.remove('cart-open', 'nav-open', 'search-open');
    if (releaseTrap) { releaseTrap(); releaseTrap = null; }
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
    lastFocus = null;
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });
  on('#scrim', 'click', closeDrawers);
  on('[data-close]', 'click', function (e) { e.preventDefault(); closeDrawers(); });

  on('[data-cart-open]', 'click', function (e) {
    if (!window.theme.cartDrawer) return;
    e.preventDefault();
    openDrawer('cart-open', document.getElementById('drawer'));
  });

  on('[data-nav-open]', 'click', function (e) {
    e.preventDefault();
    openDrawer('nav-open', document.getElementById('mobile-nav'));
  });

  on('[data-search-open]', 'click', function (e) {
    e.preventDefault();
    openDrawer('search-open', document.getElementById('search-drawer'));
    var input = document.querySelector('#search-drawer input[type="search"]');
    if (input) input.focus();
  });

  /* ---------- cart ---------- */
  function swap(sections, key, selector) {
    if (!sections || !sections[key]) return;
    var doc = new DOMParser().parseFromString(sections[key], 'text/html');
    var fresh = doc.querySelector(selector);
    var current = document.querySelector(selector);
    if (fresh && current) current.replaceWith(fresh);
  }

  function renderCart(sections) {
    swap(sections, 'cart-drawer', '#drawer');
    swap(sections, 'header', '[data-cart-count]');
  }

  function cartRequest(url, payload) {
    payload.sections = 'cart-drawer,header';
    payload.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.description) throw new Error(data.description);
        renderCart(data.sections);
        return data;
      });
  }

  /* quick add from a product card */
  on('[data-quick-add]', 'click', function (e, btn) {
    e.preventDefault();
    if (btn.hasAttribute('disabled')) return;
    var id = btn.getAttribute('data-quick-add');
    if (!id) return;
    btn.classList.add('is-loading');
    cartRequest(window.theme.routes.cartAdd, { items: [{ id: Number(id), quantity: 1 }] })
      .then(function () {
        btn.classList.remove('is-loading');
        if (window.theme.cartDrawer) openDrawer('cart-open', document.getElementById('drawer'));
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.classList.add('has-error');
        btn.title = err.message;
      });
  });

  /* line item quantity + remove */
  on('[data-line-change]', 'click', function (e, btn) {
    e.preventDefault();
    var line = Number(btn.getAttribute('data-line'));
    var qty = Number(btn.getAttribute('data-line-change'));
    var drawer = document.getElementById('drawer');
    if (drawer) drawer.classList.add('is-loading');
    cartRequest(window.theme.routes.cartChange, { line: line, quantity: qty });
  });

  /* product form */
  on('[data-product-form]', 'submit', function (e, form) {
    if (!window.theme.cartDrawer) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    var fd = new FormData(form);
    var payload = { items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }] };
    var sellingPlan = fd.get('selling_plan');
    if (sellingPlan) payload.items[0].selling_plan = Number(sellingPlan);
    cartRequest(window.theme.routes.cartAdd, payload)
      .then(function () {
        if (btn) btn.classList.remove('is-loading');
        openDrawer('cart-open', document.getElementById('drawer'));
      })
      .catch(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* ---------- protocol builder carousel ----------
     The one place this file formats money. The stack total has to follow
     the customer's ticks as they make them, and a server round trip per
     tick would lag. It is display only: what anyone pays is worked out by
     the cart, which re-renders from Liquid like everywhere else. */
  function money(cents) {
    var fmt = window.theme.moneyFormat || '${{amount}}';
    function group(dp, th, dec) {
      var parts = (cents / 100).toFixed(dp).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return group(0, ',', '.');
      if (key === 'amount_with_comma_separator') return group(2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return group(0, '.', ',');
      return group(2, ',', '.');
    });
  }

  function stackPicked(stack) {
    var ids = [];
    stack.querySelectorAll('.mod-cb').forEach(function (cb) {
      if (cb.checked && !cb.disabled) ids.push(cb.value);
    });
    return ids;
  }

  function stackUpdate(stack) {
    var total = 0, ids = [];
    stack.querySelectorAll('.mod-cb').forEach(function (cb) {
      var picked = cb.checked && !cb.disabled;
      var tile = cb.closest('[data-stack-tile]');
      if (tile) tile.classList.toggle('mod--on', picked);
      if (picked) { total += Number(cb.getAttribute('data-price')) || 0; ids.push(cb.value); }
    });

    /* same rounding as the Liquid: times pct, integer divide by 100 */
    var pct = Number(stack.getAttribute('data-pct')) || 0;
    var was = stack.querySelector('[data-stack-was]');
    var now = stack.querySelector('[data-stack-total]');
    if (was) was.textContent = money(total);
    if (now) now.textContent = money(pct > 0 ? total - Math.floor(total * pct / 100) : total);

    var count = stack.querySelector('[data-stack-count]');
    if (count) count.textContent = ids.length + ' ' + stack.getAttribute(ids.length === 1 ? 'data-one' : 'data-other');

    /* the preset keeps its name; anything hand-built is the customer's own */
    var label = stack.querySelector('[data-stack-label]');
    var custom = stack.getAttribute('data-label-custom');
    if (label) {
      label.textContent = (!custom || ids.slice().sort().join() === stack._preset)
        ? stack.getAttribute('data-label') : custom;
    }

    var form = document.getElementById(stack.getAttribute('data-form'));
    var btn = form && form.querySelector('[type="submit"]');
    if (btn) btn.disabled = ids.length === 0;
  }

  function stackArrows(stack) {
    var rail = stack.querySelector('[data-stack-rail]');
    var prev = stack.querySelector('[data-stack-prev]');
    var next = stack.querySelector('[data-stack-next]');
    if (!rail || !prev || !next) return;
    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
  }

  function initStacks(root) {
    (root || document).querySelectorAll('[data-stack]').forEach(function (stack) {
      if (stack._ready) return;
      stack._ready = true;
      /* defaultChecked is the markup, so a back-button form restore cannot
         move what counts as the preset */
      var preset = [];
      stack.querySelectorAll('.mod-cb').forEach(function (cb) {
        if (cb.defaultChecked && !cb.disabled) preset.push(cb.value);
      });
      stack._preset = preset.sort().join();
      var rail = stack.querySelector('[data-stack-rail]');
      if (rail) {
        rail.addEventListener('scroll', function () { stackArrows(stack); }, { passive: true });
        window.addEventListener('resize', function () { stackArrows(stack); });
      }
      stackUpdate(stack);
      stackArrows(stack);
    });
  }

  on('[data-stack] .mod-cb', 'change', function (e, cb) {
    stackUpdate(cb.closest('[data-stack]'));
  });

  /* a product with options (EAA flavors): the pick follows the select, and
     choosing a flavor ticks the tile */
  on('[data-stack-variant]', 'change', function (e, sel) {
    var tile = sel.closest('[data-stack-tile]');
    var cb = tile && tile.querySelector('.mod-cb');
    var opt = sel.options[sel.selectedIndex];
    if (!cb || !opt) return;
    cb.value = sel.value;
    cb.setAttribute('data-price', opt.getAttribute('data-price'));
    var price = tile.querySelector('[data-stack-price]');
    if (price) price.textContent = money(Number(opt.getAttribute('data-price')));
    tile.querySelectorAll('[data-stack-img]').forEach(function (img) {
      img.hidden = img.getAttribute('data-stack-img') !== sel.value;
    });
    cb.checked = true;
    stackUpdate(tile.closest('[data-stack]'));
  });

  on('[data-stack-prev], [data-stack-next]', 'click', function (e, btn) {
    var stack = btn.closest('[data-stack]');
    var rail = stack && stack.querySelector('[data-stack-rail]');
    if (!rail || !rail.children.length) return;
    var a = rail.children[0], b = rail.children[1];
    var step = b ? b.offsetLeft - a.offsetLeft : a.offsetWidth;
    var per = Math.max(1, Math.floor(rail.clientWidth / step));
    var smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
    rail.scrollBy({ left: (btn.hasAttribute('data-stack-prev') ? -1 : 1) * step * per, behavior: smooth ? 'smooth' : 'auto' });
  });

  on('[data-stack-form]', 'submit', function (e, form) {
    if (!window.theme.cartDrawer) return;
    var stack = document.querySelector('[data-stack][data-form="' + form.id + '"]');
    if (!stack) return;
    e.preventDefault();
    var items = stackPicked(stack).map(function (id) { return { id: Number(id), quantity: 1 }; });
    if (!items.length) return;
    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('.cfg-err');
    if (err) err.remove();
    if (btn) btn.classList.add('is-loading');
    cartRequest(window.theme.routes.cartAdd, { items: items })
      .then(function () {
        if (btn) btn.classList.remove('is-loading');
        openDrawer('cart-open', document.getElementById('drawer'));
      })
      .catch(function (error) {
        if (btn) btn.classList.remove('is-loading');
        var p = document.createElement('p');
        p.className = 'cfg-err';
        p.setAttribute('role', 'alert');
        p.textContent = error.message;
        form.appendChild(p);
      });
  });

  /* ---------- predictive search ---------- */
  var searchTimer;
  on('[data-search-input]', 'input', function (e, input) {
    clearTimeout(searchTimer);
    var results = document.querySelector('[data-search-results]');
    if (!results) return;
    var q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; return; }
    searchTimer = setTimeout(function () {
      var url = window.theme.routes.predictiveSearch +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var inner = doc.querySelector('[data-search-results]');
          results.innerHTML = inner ? inner.innerHTML : '';
        });
    }, 250);
  });

  /* ---------- variant / swatch picker ---------- */
  on('[data-variant]', 'change', function (e, input) {
    var root = input.closest('[data-product-root]');
    if (!root) return;
    var data = root.querySelector('[data-variant-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var id = input.value;
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) { v = variants[i]; break; }
    }
    if (!v) return;

    var idField = root.querySelector('[name="id"]');
    if (idField) idField.value = v.id;

    var price = root.querySelector('[data-variant-price]');
    if (price && v.price_html) price.innerHTML = v.price_html;

    var serving = root.querySelector('[data-variant-serving]');
    if (serving) serving.innerHTML = v.serving_html || '';

    var btn = root.querySelector('[data-add-button]');
    if (btn) {
      btn.disabled = !v.available;
      btn.textContent = v.available
        ? btn.getAttribute('data-label-add')
        : btn.getAttribute('data-label-soldout');
    }

    if (v.image) {
      galleryShow(root, v.image, null, false);
      // thumb 1 brings back the flavour picked, not the one the page loaded on
      var gal = root.querySelector('[data-gallery-main]');
      if (gal) gal._orig = { src: v.image, srcset: null, sizes: null };
    }

    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }
  });

  on('[data-show-all]', 'click', function (e, btn) {
    e.preventDefault();
    var group = btn.closest('.swatches') || btn.parentElement;
    group.querySelectorAll('.hide').forEach(function (el) { el.classList.remove('hide'); });
    btn.remove();
  });

  /* ---------- quantity stepper ---------- */
  on('[data-qty]', 'click', function (e, btn) {
    e.preventDefault();
    var row = btn.closest('.qty');
    var input = row && row.querySelector('input[name="quantity"]');
    if (!input) return;
    var next = Number(input.value || 1) + Number(btn.getAttribute('data-qty'));
    input.value = Math.max(1, next);
  });

  /* ---------- gallery ----------
     The main image carries a srcset, and a srcset beats src, so a swap has to
     drop it or the browser keeps drawing the first picture. Thumb 1 puts the
     original back (the cutout, where there is one); the others are photos and
     the supplement facts label, shown edge to edge. */
  function galleryShow(root, url, full, photo) {
    var gal = root && root.querySelector('[data-gallery-main]');
    var main = gal && gal.querySelector('img');
    if (!main || !url) return;
    if (!gal._orig) gal._orig = { src: main.getAttribute('src'), srcset: main.getAttribute('srcset'), sizes: main.getAttribute('sizes') };
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = url;
    gal.classList.toggle('is-photo', !!photo);
    gal.setAttribute('data-full', full || url);
  }

  function galleryReset(root) {
    var gal = root && root.querySelector('[data-gallery-main]');
    var main = gal && gal.querySelector('img');
    if (!main || !gal._orig) return;
    if (gal._orig.srcset) main.setAttribute('srcset', gal._orig.srcset);
    if (gal._orig.sizes) main.setAttribute('sizes', gal._orig.sizes);
    main.src = gal._orig.src;
    gal.classList.remove('is-photo');
    gal.removeAttribute('data-full');
  }

  on('[data-thumb]', 'click', function (e, btn) {
    e.preventDefault();
    var root = btn.closest('[data-product-root]');
    if (!root) return;
    if (btn.hasAttribute('data-thumb-first')) galleryReset(root);
    else galleryShow(root, btn.getAttribute('data-thumb'), btn.getAttribute('data-full'), true);
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === btn ? 'true' : 'false');
    });
  });

  on('[data-gallery-zoom], [data-gallery-main] img', 'click', function (e, el) {
    var root = el.closest('[data-product-root]');
    var gal = root && root.querySelector('[data-gallery-main]');
    var dlg = root && root.querySelector('[data-zoom]');
    if (!gal || !dlg || !dlg.showModal) return;
    e.preventDefault();
    var main = gal.querySelector('img');
    var img = dlg.querySelector('[data-zoom-img]');
    img.src = gal.getAttribute('data-full') || main.currentSrc || main.src;
    img.alt = main.alt;
    dlg.classList.remove('is-zoomed');
    dlg.showModal();
  });

  on('[data-zoom-close]', 'click', function (e, btn) { btn.closest('dialog').close(); });

  on('[data-zoom]', 'click', function (e, dlg) {
    if (e.target === dlg || e.target.hasAttribute('data-zoom-stage')) dlg.close();
  });

  /* Tap to zoom in on the spot that was tapped, tap again to fit. */
  on('[data-zoom-img]', 'click', function (e, img) {
    var dlg = img.closest('dialog'), stage = img.parentElement;
    var r = img.getBoundingClientRect();
    var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
    dlg.classList.toggle('is-zoomed');
    if (dlg.classList.contains('is-zoomed')) {
      stage.scrollLeft = fx * img.offsetWidth - stage.clientWidth / 2;
      stage.scrollTop = fy * img.offsetHeight - stage.clientHeight / 2;
    }
  });

  /* ---------- accordions ---------- */
  on('.acc > button', 'click', function (e, btn) {
    e.preventDefault();
    btn.parentElement.classList.toggle('open');
  });

  /* ---------- product recommendations ---------- */
  function loadRecommendations() {
    document.querySelectorAll('[data-related-url]').forEach(function (el) {
      var url = el.getAttribute('data-related-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('.wrap');
          if (!fresh) return;
          var current = el.querySelector('.wrap');
          if (current) { current.replaceWith(fresh); } else { el.appendChild(fresh); }
          el.removeAttribute('data-related-url');

          /* An image injected after load with loading="lazy" does not always
             get picked up if it is already inside the viewport - it never
             crosses the threshold, because it was born past it. Anything
             already on screen is switched to eager; anything below the fold
             stays lazy and loads on scroll as normal. */
          fresh.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
            var r = img.getBoundingClientRect();
            if (r.top < window.innerHeight && r.bottom > 0) {
              img.loading = 'eager';
              img.src = img.src;
            }
          });

          init(el);
        })
        .catch(function () { /* the collection fallback is already on the page */ });
    });
  }

  /* ---------- widont ----------
     Never strand a single word on the last line. text-wrap:pretty is
     best-effort and gives up in narrow columns; binding the final two
     words with a non-breaking space is deterministic at every width. */
  function widont(root) {
    var sel = 'h1,h2,h3,.lede,.desc,.syscard p,.sec-head p:not(.eyebrow),blockquote,.cal p,.std p,.steps span,.li h5,.up small';
    (root || document).querySelectorAll(sel).forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var n, target = null;
      while ((n = w.nextNode())) { if (/\s\S/.test(n.textContent)) target = n; }
      if (!target) return;
      var t = target.textContent.replace(/\s+(\S+)(\s*)$/, '\u00A0$1$2');
      if (t !== target.textContent) target.textContent = t;
    });
  }

  /* ---------- scroll reveal + hero counters ----------
     Progressive: the hidden state is added by JS, so if this never
     runs the page is static and fully visible. */
  var motionSeen = new WeakSet();

  function initMotion(root) {
    root = root || document;
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    var groups = [['.sec-head', 0], ['.syscard', 60], ['.card', 50], ['.std', 70],
      ['.rev', 70], ['.cal', 60], ['.mod', 70], ['.steps li', 60], ['.subs-box', 0]];

    var io = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (es) {
        es.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('in'); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 })
      : null;

    groups.forEach(function (g) {
      root.querySelectorAll(g[0]).forEach(function (el, i) {
        if (motionSeen.has(el)) return;
        motionSeen.add(el);
        if (g[1]) el.style.transitionDelay = Math.min(i * g[1], 320) + 'ms';
        if (!io || reduce) { el.classList.add('in'); return; }
        io.observe(el);
      });
    });

    if (!reduce && 'IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (es) {
        es.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          cio.unobserve(entry.target);
          var el = entry.target, raw = el.textContent.trim();
          var m = raw.match(/^(\d+)(.*)$/);
          if (!m) return;
          var end = +m[1], suffix = m[2], t0 = performance.now(), dur = 1100;
          (function step(now) {
            var p = Math.min(1, (now - t0) / dur), eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(end * eased) + suffix;
            if (p < 1) requestAnimationFrame(step);
          })(t0);
        });
      }, { threshold: 0.6 });
      root.querySelectorAll('.readout .v').forEach(function (el) { cio.observe(el); });
    }
  }

  /* ---------- Pop Convert skin ----------
     Pop Convert renders inside an OPEN shadow root on #pop-convert-app, out
     of reach of theme.css. The brand skin in snippets/pop-convert-skin.liquid
     is copied in once the app has mounted. If the app never loads, or ever
     closes its shadow root, the popup just shows in its own styling. */
  function skinPopConvert() {
    var tpl = document.getElementById('pf-pop-skin');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;
    function apply() {
      var host = document.getElementById('pop-convert-app');
      if (!host || !host.shadowRoot) return false;
      if (!host.shadowRoot.getElementById('pf-pop-skin-style')) {
        var style = tpl.content.firstElementChild.cloneNode(true);
        style.id = 'pf-pop-skin-style';
        host.shadowRoot.appendChild(style);
      }
      return true;
    }
    if (apply()) return;
    var mo = new MutationObserver(function () { if (apply()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    /* the host can land before its shadow root is attached */
    var tries = 0, poll = setInterval(function () {
      if (apply() || ++tries > 40) { clearInterval(poll); if (tries <= 40) mo.disconnect(); }
    }, 250);
  }

  function init(root) { widont(root); initMotion(root); initStacks(root); }

  function boot() { init(); loadRecommendations(); skinPopConvert(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* survive the theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#drawer')) openDrawer('cart-open', document.getElementById('drawer'));
  });
  document.addEventListener('shopify:section:deselect', closeDrawers);
})();
